import BarStepsProgress from "@components/Progress/BarStepsProgress";
import { DocumentData } from "firebase/firestore";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";

type DashboardPensionFinalProps = {
  data: DocumentData;
};

const DashboardPensionFinal: React.FC<DashboardPensionFinalProps> = ({
  data,
}) => {
  const navigate = useNavigate();
  const handleHelp = () => {
    window.location.href = "https://www.thisispenny.com/contact";
  };

  const handleComplete = () => {
    navigate("/penny-space");
  };

  // Return early if data is not properly loaded
  if (!data || typeof data !== 'object') {
    return (
      <div className="px-4 pb-6 lg:px-[80px] md:py-10 bg-pn_paper-3 flex flex-col gap-y-0 md:gap-y-6">
        <div className="p-4 md:p-0">
          <BarStepsProgress activeStep={4} />
        </div>
        <div className="flex items-center justify-center p-6 rounded-2xl border border-pn_gray-200 bg-pn_white">
          <span className="text-pn-body-large-regular text-pn_gray-600">
            Loading your pension information...
          </span>
        </div>
      </div>
    );
  }

  return data?.process_final_pension_application &&
    !data?.final_pension_application ? (
    <div className="px-4 pb-6 lg:px-[80px] md:py-10 bg-pn_paper-3 flex flex-col gap-y-0 md:gap-y-6">
      <div className="p-4 md:p-0">
        <BarStepsProgress activeStep={4} />
      </div>

      <div className="flex flex-col gap-y-6 md:gap-y-0 md:flex-row p-6 gap-x-6 rounded-2xl border border-pn_gray-200 bg-pn_white">
        <div className="w-[60px] h-[60px] rounded-full bg-pn_paper-3 flex items-center justify-center">
          <ClockIcon className="w-8 h-8" />
        </div>

        <div className="flex flex-col gap-y-6 items-start md:items-center md:flex-row gap-x-3 justify-between flex-1 md:gap-y-2">
          <div className="flex flex-col gap-y-1 flex-1">
            <span className="text-pn-body-large-emphasis text-pn_gray-950">
              Waiting for your Zurich process completion
            </span>
            <span className="text-pn-body-small-regular text-pn_gray-600">
              {data?.first_name}, completing your Zurich details to
              continue with your journey. If you need help, don't hesitate in
              contacting us
            </span>
          </div>

          <button
            onClick={handleHelp}
            className="btn-tertiary-sm py-1 inline-block w-fit"
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className="bg-[#F4E34E] flex items-start overflow-hidden pt-6 pb-6 md:pb-0 md:pt-[60px] justify-between px-4 lg:px-[80px] gap-x-[10%]">
      <div className="flex flex-col gap-y-0 md:gap-y-[30px] max-w-[410px] w-full">
        <div className="flex flex-col gap-y-[11px] py-4 md:py-0">
          <span className="text-pn-large-title text-pn_gray-950">
            You are Penny ready!
          </span>
          <span className="text-pn-body-large-regular capitalize text-pn_gray-600">
            {data?.first_name}, your pension is now ready, and our mission is
            now more attainable. Stay tuned there more things coming your way
          </span>
        </div>

        <div className="flex items-center gap-x-5 py-4 md:py-0">
          <button
            onClick={handleComplete}
            className="btn-primary-sm-40 !bg-pn_yellow-50"
          >
            Dashboard
          </button>
          {/* <button className="btn-tertiary-sm">Label</button> */}
        </div>
      </div>

      <div
        style={{
          boxShadow:
            "0px 24px 32px -8px rgba(0, 0, 0, 0.10), 0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        }}
        className="bg-pn_pink-200 rounded-tl-2xl pb-[99px] rounded-tr-2xl max-w-[590px] w-full p-6 hidden md:flex items-start justify-between gap-x-[2.5%]"
      >
        <div className="flex flex-col gap-y-2">
          <span className="text-[18px] lg:text-[22px] font-medium leading-[30px]">
            Early Member Club
          </span>
          <span className="font-eightiescomeback text-[32px] lg:text-[44px] leading-[45px] lg:leading-[60px]">
            <span className="capitalize">{data?.first_name}</span>{" "}
            <span className="capitalize">{data?.last_name}</span>
          </span>
          <span className="text-[18px] uppercase lg:text-[22px] font-medium leading-[30px] text-pn_pink-400">
            #{data?.uid?.slice(0, 5) || '00000'}
          </span>
        </div>

        <div className="pt-[3px] lg:pr-[21px]">
          <PennyIcon className="w-[62px] h-[69px]" />
        </div>
      </div>

      {/* <div className="p-6 flex flex-col gap-y-4 items-center justify-center">
        <div>
          <PennyIcon width={24} height={24} />
        </div>
        <div className="flex flex-col gap-y-2">
          <span className="text-pn-headline-emphasis text-pn_gray-950">
            Penny Pension Ready
          </span>
          <span className="text-pn-callout-regular text-pn_gray-600">
            {data?.first_name}, your pension is now ready, and our mission is
            now more attainable. Stay tuned there more things coming your way
          </span>
        </div>

        <button className="btn-secondary-sm !bg-pn_gray-950 !text-pn_white w-full !py-3">
          Subscribe
        </button>
      </div> */}
    </div>
  );
};
export default DashboardPensionFinal;
